'use client';

import { __makeTemplateObject } from '../_virtual/_tslib.js';
import styled from 'styled-components';
import { colors } from '../Colors/index.js';

var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n    ", "\n"], ["\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n    ", "\n"])), function (_a) {
    var haveDefaultBackgroundColor = _a.haveDefaultBackgroundColor, isExpand = _a.isExpand;
    return haveDefaultBackgroundColor
        ? "\n                background-color: ".concat(isExpand ? colors.primary[100] : colors.neutral[99], ";\n            ")
        : '';
});
var AccordionSummary = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    position: relative;\n    z-index: 3;\n    width: ", ";\n"], ["\n    position: relative;\n    z-index: 3;\n    width: ", ";\n"])), function (_a) {
    var $isHaveExpandIcon = _a.$isHaveExpandIcon;
    return ($isHaveExpandIcon ? 'calc(100% - 36px)' : '100%');
});
var IconWrapper = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    position: absolute;\n    z-index: 5;\n    padding: 4px;\n    top: 50%;\n    right: -36px;\n    cursor: pointer;\n    transition: transform 0.25s ease-in-out;\n    transform: translateY(-50%) rotate(", "deg);\n"], ["\n    position: absolute;\n    z-index: 5;\n    padding: 4px;\n    top: 50%;\n    right: -36px;\n    cursor: pointer;\n    transition: transform 0.25s ease-in-out;\n    transform: translateY(-50%) rotate(", "deg);\n"])), function (_a) {
    var isExpand = _a.isExpand;
    return (isExpand ? '0' : '180');
});
var AccordionDetails = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    ", "\n"], ["\n    ", "\n"
    // transition: height 0.25s ease-in-out, opacity 0.2s ease-out;
])), function (_a) {
    var enableMaskImage = _a.enableMaskImage, isExpand = _a.isExpand;
    return enableMaskImage && isExpand ? 'mask-image: linear-gradient(180deg, #fff, transparent);' : '';
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
// transition: height 0.25s ease-in-out, opacity 0.2s ease-out;

export { AccordionDetails, AccordionSummary, Container, IconWrapper };
//# sourceMappingURL=styled.js.map
